import React, { useEffect, useState } from 'react';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import { config } from '../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import axios from "axios";
import { ImagePdfBucket } from '../CommonUtils/ImagesBase64';
import { useNavigate } from 'react-router-dom';
import allowNumbersOnly from '../CommonUtils/CommonValidations';
import { BiRefresh } from 'react-icons/bi';
import { TfiReload } from 'react-icons/tfi';
import TrackUrConcern from './NOCReports/TrackUrConcern';
import { successAlert2, successAlertRefresh } from '../CommonUtils/SweetAlerts';
import { CommonAxiosPost } from '../CommonUtils/CommonAxios';

export const NOC_TYPE_MAP = {
    // "Merger of Institutions": "merge_ofinstructions",
    // "Conversion of the Institution": "type_converstions",
    // "Closure of Institution": "closure_of_institutions",
    "Extension of Permission (EoP)": "eop",
    "Shifting of the Institution": "shifting",

    // "Trust / Society Name Change": "society_name_change",
    "New Programme/ Section /Conversion of Programme": "intake_changes",
    "Change of Institution Name": "change_of_inst_name",
    "Management Change / Society": "management"
};

export default function Grievance() {
    const username = sessionStorage.getItem("user_name");
    const userId = sessionStorage.getItem("user_id");
    function generateCaptcha(length = 5) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const array = new Uint32Array(length);
        crypto.getRandomValues(array);
        return Array.from(array, num => chars[num % chars.length]).join('');
    }
    const navigate = useNavigate();
    const [captcha, setCaptchaa] = useState('');
    const [mode, setMode] = useState('raise');
    useEffect(() => { setCaptchaa(generateCaptcha()); }, []);
    const handleRefresh = () => setCaptchaa(generateCaptcha());
    // FIX 1: validationSchema defined inside component so it can reference otpSent state
    const validationSchema = Yup.object({
        // collCode: Yup.string().required("College Code is required"),
        nocType: Yup.string().required("Please select NOC Type"),
        pblmType: Yup.string().required("Please select Problem Type"),
        grievance: Yup.string()
            .required("Concern is required")
            .min(10, "Minimum 10 characters required"),
        mobileno: Yup.string()
            .required("Mobile number is required")
            .matches(/^[0-9]{10}$/, "Enter valid 10 digit mobile number"),
        captcha: Yup.string().required("Captcha is required")
    });

    const InstitutionFormik = useFormik({
        initialValues: {
            collCode: "",
            // instName: "",
            nocType: "",
            grievance: "",
            grievupload: "",
            pblmType: "",
            mobileno: "",
            captcha: "",
            // cllgType: ""
        },
        validationSchema,
        enableReinitialize: false,

        onSubmit: (values) => {

            if (values.captcha !== captcha) {
                Swal.fire("Invalid Captcha", "", "error");
                return;
            }

            Swal.fire({
                text: "Are you sure you want to submit?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, submit it!",
                cancelButtonText: "No, cancel!",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = config.url.FAC_URL + "saveGrievance";

                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === "01") {

                            successAlertRefresh(res?.data?.sdesc)
                        } else {
                            Swal.fire(res?.data?.sdesc || "Failed", "", "error");
                        }
                    });
                }
            });
        }
    });



    const [showForm, setShowForm] = useState(false);

    const getInstTypeLabel = (type) => {
        switch (type) {
            case 113:
            case 124:
            case 102:
                return "Engineering";
            case 135:
            case 138:
                return "Pharmacy";
            case 118:
                return "Degree";
            case 145:
                return "PG";
            case 104:
            case 122:
                return "B.ED";
            case 131:
            case 142:
                return "LAW";
            case 111:
            case 147:
                return "MBA";
            case 136:
                return "MCA";
            case 140:
                return "Paramedical";
            case 128:
                return "Horticulture";
            case 115:
                return "Polytechnic";
            default:
                return "Unknown";
        }
    };
    const handleModeChange = (selectedMode) => {
        setMode(selectedMode);
        InstitutionFormik.resetForm();
        setShowForm(false);
        setCaptchaa(generateCaptcha());
    };
    const goToHome = () => {
        navigate('/');
    };
    return (
        <>
            <header className="top-header top-headerfoot">
                <div className="par-logopart">
                    <img src="../images/MAINLOGO.png" alt="" className="img-fluid" />
                    <div className="paralogo-text">
                        <h4 className="mb-0">Higher Education Department</h4>
                        <p className="mb-0">Government of Andhra Pradesh</p>
                    </div>
                </div>
            </header>
            <h2 className="newclg-title">Concern Center</h2>
            <p className="newclg-subtitle">Choose an option</p>

            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "30px",
                marginBottom: "20px"
            }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "16px", fontWeight: 500 }}>
                    <input
                        type="radio"
                        value="raise"
                        checked={mode === 'raise'}
                        onChange={() => handleModeChange('raise')}
                    // onChange={() => setMode('raise')}
                    />
                    Raise a Concern
                </label>

                <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "16px", fontWeight: 500 }}>
                    <input
                        type="radio"
                        value="track"
                        checked={mode === 'track'}
                        onChange={() => handleModeChange('track')}
                    // onChange={() => setMode('track')}
                    />
                    Track Your Concern
                </label>

                {/* Back Button */}
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: "6px",
                        background: "#2563eb",
                        color: "#fff",
                        cursor: "pointer",
                        fontWeight: 600
                    }}
                >
                    Back
                </button>

            </div>


            {mode === 'track' && (
                <TrackUrConcern />

            )}
            {mode === 'raise' && (
                <>
                    <div className="newclgnew-bg">
                        <div className="newclg-card">
                            <h2 className="newclg-title">Raise your Concern</h2>
                            <p className="newclg-subtitle">Fill details to continue</p>

                            <FormikProvider value={InstitutionFormik}>
                                <Form onSubmit={InstitutionFormik.handleSubmit}>

                                    <div className="newclg-field">
                                        <label>Institute Name</label>

                                        <div className="d-flex gap-2 align-items-start">
                                            <div style={{ flex: 1 }}>
                                                <Field
                                                    type="text"
                                                    name="collCode"
                                                    className="form-control"
                                                    disabled
                                                    value={`${username}-${userId}`}

                                                />
                                                <ErrorMessage name="collCode" component="div" className="text-danger" />
                                            </div>


                                        </div>
                                    </div>

                                    {/* 
                                    <div className="newclg-field">
                                        <label>Enter College Name</label>
                                        <Field type="text" name="instName" className="form-control" disabled />
                                        <ErrorMessage name="instName" component="div" className="text-danger" />
                                    </div>
                                    <div className="newclg-field">
                                        <label>College Type</label>
                                        <Field type="text" name="cllgType" className="form-control" disabled />
                                        <ErrorMessage name="cllgType" component="div" className="text-danger" />
                                    </div> */}
                                    <div className="newclg-field">
                                        <label> NOC Service Type</label>
                                        <Field as="select" name="nocType" className="form-control">
                                            <option value="">--Select--</option>
                                            {Object.entries(NOC_TYPE_MAP).map(([label, value]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="nocType" component="div" className="text-danger" />
                                    </div>


                                    <div className="newclg-field">
                                        <label>Enter Mobile No</label>
                                        <div style={{ display: "flex", gap: "10px" }}>
                                            <Field
                                                type="text"
                                                name="mobileno"
                                                className="form-control"
                                                maxLength="10"
                                            />

                                        </div>
                                        <ErrorMessage name="mobileno" component="div" className="text-danger" />
                                    </div>
                                    <div className="newclg-field">
                                        <label>Type of Problem</label>
                                        <Field as="select" name="pblmType" className="form-control">
                                            <option value="">--Select--</option>
                                            <option value="T">Technical</option>
                                            <option value="A">Administartive</option>
                                        </Field>
                                        <ErrorMessage name="pblmType" component="div" className="text-danger" />
                                    </div>
                                    <div className="newclg-field">
                                        <label>Enter Concern Details</label>
                                        <Field
                                            as="textarea"
                                            name="grievance"
                                            className="form-control"
                                            style={{ height: "120px" }}
                                        />
                                        <ErrorMessage name="grievance" component="div" className="text-danger" />
                                    </div>


                                    <div className="newclg-field">
                                        <label>Upload File</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="grievupload"
                                            accept="application/pdf"
                                            onChange={(e) => {
                                                ImagePdfBucket(e, InstitutionFormik, "/Uploads/grievupload/", "grievupload", "grievupload", "pdf");
                                            }}
                                        />
                                    </div>



                                    <div className="newclg-field">
                                        <label>Enter Captcha</label>

                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <div
                                                style={{
                                                    background: "#f1f1f1",
                                                    padding: "8px 12px",
                                                    fontWeight: "bold",
                                                    letterSpacing: "2px",
                                                    width: "180px", height: "45px", fontSize: "18px",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {captcha}
                                            </div>

                                            {/* <button
                                                type="button"
                                                className="btn btn-sm btn-secondary"
                                                onClick={handleRefresh}
                                            >
                                               <BiRefresh  spin />

                                              
                                            </button> */}
                                            <button type="button" className="btn btn-outline-secondary" onClick={handleRefresh} title="Refresh Captcha">
                                                <TfiReload size={16} />
                                            </button>
                                        </div>

                                        <Field
                                            type="text"
                                            name="captcha"
                                            className="form-control mt-2"
                                            placeholder="Enter captcha"
                                        />

                                        <ErrorMessage name="captcha" component="div" className="text-danger" />
                                    </div>
                                    <div className="text-end mt-3">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>



                                </Form>
                            </FormikProvider>
                        </div>
                    </div>
                </>

            )}
            <footer className='forgot-footer'>
                <p className='mb-0'>
                    Designed and Developed by
                    <a href='https://apcfss.in/' target='_blank' rel="noreferrer">
                        <img src='../images/footer-logo.svg' alt='' className='img-fluid' />
                    </a>
                </p>
            </footer>

        </>
    );
}